<script setup lang="ts">
/**
 * A painted game icon from frontend/public/art/ui/icons/ (cut from the kit's
 * icon sheets by scripts/assets/kit-intake.mjs). Decorative unless `label` is
 * given, in which case it is the image's accessible name.
 */
import type { GameIconName } from './icons';

withDefaults(defineProps<{ name: GameIconName; size?: number; label?: string }>(), { size: 32, label: '' });
</script>

<template>
  <img
    class="game-icon"
    :src="`/art/ui/icons/${name}.webp`"
    :width="size"
    :height="size"
    :alt="label"
    :aria-hidden="label ? undefined : 'true'"
    decoding="async"
    draggable="false"
  />
</template>

<style scoped>
.game-icon {
  flex: none;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 2px 0 rgba(0, 0, 0, 0.45));
  user-select: none;
}
</style>
